import React from "react"
import { Box } from "@shared-components/Box/Box"
import {
  heroStyle,
  heroRatioStyle,
  heroContentStyles,
  headingStyle,
} from "./styles"
import { UmbracoBackgroundImage } from "@shared-components/Image/UmbracoBackgroundImage/UmbracoBackgroundImage"
import { SmallHeroModule } from "../../carlsberg-headless/types/modules/SmallHero"
import { Heading } from "@shared-components/Heading/Heading"

export type SmallHeroProps = SmallHeroModule

const SmallHero: React.FC<SmallHeroProps> = ({ headline, image, cbKey }) => {
  return (
    <Box key={cbKey} sx={heroStyle}>
      <Box sx={heroRatioStyle}>
        {image && image.fullUrl && (
          <UmbracoBackgroundImage
            image={image}
            height={[650, 760]}
            lazyLoadOffset={0}
          />
        )}
        <Box sx={heroContentStyles}>
          {headline && (
            <Heading as="h1" sx={headingStyle}>
              {headline}
            </Heading>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export { SmallHero }
